// src/components/CommissionsHeader.jsx
// ============================================================================
// BLOCK COMM.HEADER.0 — Sortable header (mirrors ProdMgrs header behavior)
// ============================================================================

import React from 'react';

import InfoIcon from '@mui/icons-material/Info';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Tooltip from '@mui/material/Tooltip';

function SortCell({ id, label, active, direction, onClick }) {
  return (
    <TableCell variant="head">
      <TableSortLabel
        active={active}
        direction={active ? direction : 'asc'}
        onClick={() => onClick(id)}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
}

function CommGrossCommissionsHeader({ isRep, sortBy, sortDir, onSort }) {
  return (
    <TableHead>
      <TableRow>
        <SortCell
          id="InvoiceNo"
          label="Invoice"
          active={sortBy === 'InvoiceNo'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="InvoiceDate"
          label="Invoice Date"
          active={sortBy === 'InvoiceDate'}
          direction={sortDir}
          onClick={onSort}
        />

        <SortCell
          id="Customer"
          label="Customer"
          active={sortBy === 'Customer'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="CustomerPONo"
          label="Customer PO#"
          active={sortBy === 'CustomerPONo'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="TrackingID"
          label="Tracking"
          active={sortBy === 'TrackingID'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="State"
          label="State"
          active={sortBy === 'State'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="AreaCode"
          label="Area Code"
          active={sortBy === 'AreaCode'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="City"
          label="City"
          active={sortBy === 'City'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="Reps"
          label="Reps"
          active={sortBy === 'Reps'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="Item"
          label="Item"
          active={sortBy === 'Item'}
          direction={sortDir}
          onClick={onSort}
        />

        <SortCell
          id="ProductGroup"
          label="Product Group"
          active={sortBy === 'ProductGroup'}
          direction={sortDir}
          onClick={onSort}
        />

        <SortCell
          id="Quantity"
          label="Quantity"
          active={sortBy === 'Quantity'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="UnitPrice"
          label="Unit Price"
          active={sortBy === 'UnitPrice'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="Sale"
          label="Sale"
          active={sortBy === 'Sale'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="BaseCost"
          label="Base Cost"
          active={sortBy === 'BaseCost'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="ContractFee"
          label="Contract Fee"
          active={sortBy === 'ContractFee'}
          direction={sortDir}
          onClick={onSort}
        />

        <SortCell
          id="NetSale"
          label="Net Sale"
          active={sortBy === 'NetSale'}
          direction={sortDir}
          onClick={onSort}
        />

        {/* Tooltipped columns are computed; keep as non-sort for now */}
        <TableCell variant="head">
          <Tooltip
            data-cy="running-total-tooltip"
            title="Running gross sales per Product Group for the selected year. This is the amount used to determine the annual gross commission tier."
          >
            <span>
              <InfoIcon sx={{ fontSize: 'small' }} /> Running Gross Total
            </span>
          </Tooltip>
        </TableCell>

        <TableCell variant="head">
          <Tooltip
            data-cy="running-net-total-tooltip"
            title="Reference only: running net sales total per Product Group for each month. Gross commission tiers do not use this value."
          >
            <span>
              <InfoIcon sx={{ fontSize: 'small' }} /> Running Net Total (Ref)
            </span>
          </Tooltip>
        </TableCell>

        {isRep && (
          <>
            <SortCell
              id="CommissionRate"
              label="% Commission"
              active={sortBy === 'CommissionRate'}
              direction={sortDir}
              onClick={onSort}
            />
            <SortCell
              id="LineCommissions"
              label="Commission"
              active={sortBy === 'LineCommissions'}
              direction={sortDir}
              onClick={onSort}
            />
            {/* This is usually derived; keep non-sort unless you have a field */}
            <TableCell variant="head">Total Commission</TableCell>
          </>
        )}
      </TableRow>
    </TableHead>
  );
}

export default React.memo(CommGrossCommissionsHeader);
